import React from 'react';
import { formatMomentDate } from '../../../utils/momentDates';

export const SourceChips = ({ ids = [], moments = [], onOpen }) => {
  const list = ids.map((id) => moments.find((m) => m.id === id)).filter(Boolean);
  if (!list.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5 mt-1.5">
      {list.map((m) => (
        <button
          key={m.id}
          type="button"
          onClick={() => onOpen(m)}
          className="max-w-[14rem] truncate rounded-full border border-violet-200 bg-white px-2.5 py-0.5 text-[11px] font-semibold text-violet-700 hover:bg-violet-100"
          title="Open this Moment"
        >
          {formatMomentDate(m.occurred_at)}{m.title ? ` · ${m.title}` : ''}
        </button>
      ))}
    </div>
  );
};